import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VCheckbox,
    _vm._g(
      _vm._b(
        {
          attrs: { value: _vm.selectedValue, "input-value": _vm.$attrs.value },
          on: { change: _vm.$listeners.input },
          scopedSlots: _vm._u(
            [
              {
                key: "label",
                fn: function () {
                  return [_vm._t("default")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        "v-checkbox",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }